import styles from "./ProductSelection.module.scss";
import { useState } from "react";
import SelectProductsModal from "./SelectProductsModal/SelectProductsModal";
import Headphones from "../../../../../assets/images/product-image-headphones.png";
import SecondaryButton from "../../../../../components/common/SecondaryButton/SecondaryButton";
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";

const ProductSelection = () => {
  const [showModal, setShowModal] = useState(false);

  const selectedProductsData = [
    {
      serialNo: 1,
      product: {
        image: Headphones,
        name: "Blue Colored Headphones",
        productId: "#123456789",
        stock: 300,
      },
    },
  ];

  const selectedProductsDatacolumns = [
    {
      name: "Serial no.",
      selector: (row) => row.serialNo,
      minWidth: "100px",
      maxWidth: "150px",
    },
    {
      name: "Product",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <div>
            <img src={row.product.image} alt="" width={86} height={79} />
          </div>
          <div>
            <div>{row.product.name}</div>
            <div>Product ID: {row.product.productId}</div>
            <div>Stock: {row.product.stock}</div>
          </div>
        </div>
      ),
      minWidth: "300px",
    },
  ];

  return (
    <div>
      <div className={styles["heading"]}>Product Selection</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <div>
            <SecondaryButton
              name="Add Product"
              onClick={() => setShowModal(!showModal)}
            />
          </div>
          <div>Can only add One Product</div>
          <div className="fw-medium">Selected Product</div>
          <DatatableComponent
            data={selectedProductsData}
            columns={selectedProductsDatacolumns}
            type="gray"
          />
        </div>
      </div>
      <SelectProductsModal
        isModalOpen={showModal}
        setIsModalOpen={setShowModal}
      />
    </div>
  );
};

export default ProductSelection;